import { gql, useQuery } from "@apollo/client";

export interface PageForDropdown {
  id: string;
  slug: string;
  title: string | null;
  status: string;
}

export const ALL_PAGES_FOR_DROPDOWN = gql`
  query AllPagesForDropdown($page: Int!, $perPage: Int!) {
    allPages(
      page: $page
      perPage: $perPage
      sortField: "title"
      sortOrder: "ASC"
      filter: { status: { eq: "published" } }
    ) {
      id
      slug
      title
      status
    }
  }
`;

export function usePagesForDropdown() {
  const { data, loading, error, refetch } = useQuery<{
    allPages: PageForDropdown[];
  }>(ALL_PAGES_FOR_DROPDOWN, {
    variables: { page: 0, perPage: 100 },
    fetchPolicy: "cache-and-network",
  });

  return {
    pages: data?.allPages ?? [],
    loading,
    error,
    refetch,
  };
}
